import { connectPagination } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

let paginationInit = false

const renderPagination = (renderOptions, isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    refine,
    createURL,
    isFirstPage,
    isLastPage,
    widgetParams,
  } = renderOptions

  if (!isFirstRender && !paginationInit) {
    const urlParams = new URLSearchParams(window.location.search)
    const currentPage = urlParams.get('offset')

    if (currentPage !== null) {
      refine(currentPage)
    }

    const themeInUrl = urlParams.get('theme')

    if (sessionStorage.getItem('pagination') && sessionStorage.getItem('prevUrl').includes('/formations/')) {
      if (!themeInUrl) {
        refine(sessionStorage.getItem('pagination'))
      }

      sessionStorage.removeItem('pagination')
    }

    paginationInit = true
  }

  if (nbPages > 1) {
    widgetParams.container.innerHTML = `
      <div class="ais-Pagination">
        <ul class="ais-Pagination-list">
          ${!isFirstPage
            ? `
              <li class="ais-Pagination-item">
                <a class="ais-Pagination-link" href="${createURL(currentRefinement - 1)}" data-value="${currentRefinement - 1}">
                  <span class="sr-only">Page précédente</span>
                  <svg width="24" height="24" class="arrow pointer-events-none">
                    <use href="#icon-arrow-left" xlink:href="#icon-arrow-left"></use>
                  </svg>
                </a>
              </li>
              ${nbPages > 5 && currentRefinement > 2
                ? `<li class="ais-Pagination-item">
                  <a href="${createURL(0)}" data-value="0" class="ais-Pagination-link">
                    1
                  </a>
                </li>`
                : ''
              }`
            : ''
          }
          ${currentRefinement > 2 && nbPages > 5
          ? `<li class="ais-Pagination-item">
            <a href="${createURL(pages[0])}" data-value="${pages[0]}" class="ais-Pagination-link">
              <span>...</span>
            </a>
          </li>`
          : ''}
          ${pages.map(page => `
            <li class="ais-Pagination-item ${currentRefinement === page ? 'ais-Pagination-item--selected' : ''}">
              <a
                href="${createURL(page)}"
                data-value="${page}"
                class="ais-Pagination-link"
                style="font-weight: ${currentRefinement === page ? 'bold' : ''}"
              >
                ${page + 1}
              </a>
            </li>
          `).join('')}
          ${currentRefinement < nbPages - 4 && nbPages > 5
          ? `<li class="ais-Pagination-item">
              <a href="${createURL(pages[pages.length - 1])}" data-value="${pages[pages.length - 1]}" class="ais-Pagination-link">
                <span>...</span>
              </a>
            </li>`
          : ''}
          ${!isLastPage
            ? `
              ${nbPages > 5 && currentRefinement < nbPages - 3
              ? `<li class="ais-Pagination-item">
                <a href="${createURL(nbPages - 1)}" data-value="${nbPages - 1}" class="ais-Pagination-link">
                  ${nbPages}
                </a>
              </li>`
              : ''
              }
              <li class="ais-Pagination-item">
                <a class="ais-Pagination-link" href="${createURL(currentRefinement + 1)}" data-value="${currentRefinement + 1}">
                  <span class="sr-only">Page suivante</span>
                  <svg width="24" height="24" class="arrow arrow--right pointer-events-none">
                    <use href="#icon-arrow-left" xlink:href="#icon-arrow-left"></use>
                  </svg>
                </a>
              </li>`
            : ''
          }
        </ul>
      </div>
    `

    widgetParams.container.querySelectorAll('a').forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault()
        refine(event.currentTarget.dataset.value)

        window.scrollTo({
          top: get('[js-training-list-header]').offsetTop,
        })
      })
    })
  } else {
    widgetParams.container.innerHTML = ''
  }
}

const customPagination = connectPagination(renderPagination)

export default customPagination
